import Api from './api';

const shippingLinesListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/lines', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createShippingLineRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/lines/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteShippingLineRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/lines/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}
const updateShippingLineRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/lines/' + data.id, data, { headers: { Authorization: 'Bearer ' + access_token } })
}


export default {
    shippingLinesListRequest,
    createShippingLineRequest,
    deleteShippingLineRequest,
    updateShippingLineRequest
}



// WEBPACK FOOTER //
// ./src/api/apiShippingLines.js